export default function FooterDivider() {
  return <div className="footersvg"></div>;
}
